export default "__VITE_ASSET__389a1c62__"